import ascSvgRaw from '@/app/icons/planets/asc.svg?raw'
import chironSvgRaw from '@/app/icons/planets/chiron.svg?raw'
import jupiterSvgRaw from '@/app/icons/planets/jupiter.svg?raw'
import lilithSvgRaw from '@/app/icons/planets/lilith.svg?raw'
import marsSvgRaw from '@/app/icons/planets/mars.svg?raw'
import mcSvgRaw from '@/app/icons/planets/mc.svg?raw'
import mercurySvgRaw from '@/app/icons/planets/mercury.svg?raw'
import moonSvgRaw from '@/app/icons/planets/moon.svg?raw'
import neptuneSvgRaw from '@/app/icons/planets/neptune.svg?raw'
import nnodeSvgRaw from '@/app/icons/planets/nnode.svg?raw'
import plutoSvgRaw from '@/app/icons/planets/pluto.svg?raw'
import saturnSvgRaw from '@/app/icons/planets/saturn.svg?raw'
import sunSvgRaw from '@/app/icons/planets/sun.svg?raw'
import uranusSvgRaw from '@/app/icons/planets/uranus.svg?raw'
import venusSvgRaw from '@/app/icons/planets/venus.svg?raw'

import { PlanetType } from '@/api/services/sweph-service/types'
import jupiterPng from '@/app/img/jupiter.png'
import lunarEclipsePng from '@/app/img/lunarEclipse.png'
import marsPng from '@/app/img/mars.png'
import mercuryPng from '@/app/img/mercury.png'
import moonPng from '@/app/img/moon.png'
import neptunePng from '@/app/img/neptune.png'
import plutoPng from '@/app/img/pluto.png'
import saturnPng from '@/app/img/saturn.png'
import solarEclipsePng from '@/app/img/solarEclipse.png'
import sunPng from '@/app/img/sun.png'
import uranusPng from '@/app/img/uranus.png'
import venusPng from '@/app/img/venus.png'

import { type NatalPointPlanetType } from '@/api/groups-natal'

export const JUPITER_PNG = jupiterPng
export const LUNAR_ECLIPSE_PNG = lunarEclipsePng
export const MARS_PNG = marsPng
export const MERCURY_PNG = mercuryPng
export const MOON_PNG = moonPng
export const NEPTUNE_PNG = neptunePng
export const PLUTO_PNG = plutoPng
export const SATURN_PNG = saturnPng
export const SOLAR_ECLIPSE_PNG = solarEclipsePng
export const SUN_PNG = sunPng
export const URANUS_PNG = uranusPng
export const VENUS_PNG = venusPng

export const PLANET_IMAGES: Record<string, string | undefined> = {
  [PlanetType.JUPITER]: JUPITER_PNG,
  [PlanetType.MARS]: MARS_PNG,
  [PlanetType.MERCURY]: MERCURY_PNG,
  [PlanetType.MOON]: MOON_PNG,
  [PlanetType.NEPTUNE]: NEPTUNE_PNG,
  [PlanetType.PLUTO]: PLUTO_PNG,
  [PlanetType.SATURN]: SATURN_PNG,
  [PlanetType.SUN]: SUN_PNG,
  [PlanetType.URANUS]: URANUS_PNG,
  [PlanetType.VENUS]: VENUS_PNG,
}

export const PLANET_RAW_SVG_MAP: Record<NatalPointPlanetType, string> = {
  Sun: sunSvgRaw,
  Moon: moonSvgRaw,
  Neptune: neptuneSvgRaw,
  Uranus: uranusSvgRaw,
  Saturn: saturnSvgRaw,
  Jupiter: jupiterSvgRaw,
  Mars: marsSvgRaw,
  Venus: venusSvgRaw,
  Mercury: mercurySvgRaw,
  Pluto: plutoSvgRaw,
  NNode: nnodeSvgRaw,
  Chiron: chironSvgRaw,
  Lilith: lilithSvgRaw,
  Asc: ascSvgRaw,
  Mc: mcSvgRaw,
}

export const PLANET_NAMES: Record<NatalPointPlanetType, string> = {
  Asc: 'Асцендент',
  Chiron: 'Хирон',
  Jupiter: 'Юпитер',
  Lilith: 'Лилит',
  Mars: 'Марс',
  Mc: 'Середина неба',
  Mercury: 'Меркурий',
  Moon: 'Луна',
  NNode: 'Северный узел',
  Neptune: 'Нептун',
  Pluto: 'Плутон',
  Saturn: 'Сатурн',
  Sun: 'Солнце',
  Uranus: 'Уран',
  Venus: 'Венера',
}

export const ASPECT_NAMES: Record<number, string> = {
  0: 'Соединение',
  60: 'Секстиль',
  90: 'Квадрат',
  120: 'Трин',
  180: 'Оппозиция',
}

export const ASPECT_SYMBOLS: Record<number, string> = {
  0: '☌',
  60: '⚹',
  90: '□',
  120: '△',
  180: '☍',
}

export type NatalAspectQuestionSource = {
  planet1: NatalPointPlanetType
  planet2: NatalPointPlanetType
  aspect: number
}

export function getNatalAspectQuestion(aspect: NatalAspectQuestionSource) {
  const aspectSymbol = ASPECT_SYMBOLS[aspect.aspect] ?? `${aspect.aspect}°`

  return `Расскажи про аспект ${PLANET_NAMES[aspect.planet1]} ${aspectSymbol} ${PLANET_NAMES[aspect.planet2]}`
}

export function getNatalAspect(aspect: NatalAspectQuestionSource) {
  const aspectSymbol = ASPECT_SYMBOLS[aspect.aspect] ?? `${aspect.aspect}°`

  return `${PLANET_NAMES[aspect.planet1]} ${aspectSymbol} ${PLANET_NAMES[aspect.planet2]}`
}
